import HospitalarLegacyClinicalBridge from '../hospitalar/HospitalarLegacyClinicalBridge';
import SharedClinicalHistoryTab from './SharedClinicalHistoryTab';
import TelehealthWorkspace from '../telehealth/TelehealthWorkspace';
import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { Container, Row, Col, Card, Spinner, Form, Button, Alert, Modal, Image, Placeholder, Nav, Tabs, Tab, Accordion, OverlayTrigger, Tooltip, InputGroup, Badge } from 'react-bootstrap';
import { usePacienteContext } from '../../PacienteContext';
import config from '../../config'; // Importar config para apiBaseURL
import axios from 'axios';
import { useEntidadeContext } from '../../EntidadeContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStethoscope, faHistory, faCamera, faSyncAlt, faEye, faFileMedical, faNotesMedical, faHeartbeat, faUserMd, faUpload, faFileSignature, faFilePrescription, faFileWaveform, faPlus, faTrash, faExclamationTriangle, faInfoCircle, faFolderOpen, faClipboardList, faTabletAlt, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import capturaFotoIcon from '../../img/capturaFoto.png';
import DatePicker from "react-datepicker";
import CreatableSelect from 'react-select/creatable';
import "react-datepicker/dist/react-datepicker.css";
import { QRCodeCanvas } from 'qrcode.react';
import AssinaturaTab from './AssinaturaTab'; // Importa o novo componente
import DocumentosTab from './DocumentosTab'; // 1. Importar o novo componente
import AtestadoTab from './AtestadoTab'; // Importar o componente de Atestado
import ReceituarioTab from './ReceituarioTab'; // Importar o componente de Receituário
import AlergiasTab from './AlergiasTab'; // Importar o componente de Alergias
import AnamneseViewTab from './AnamneseViewTab'; // Importar a visualização da anamnese
import { useAuthContext } from '../../context/AuthContext';
import { useAlertModal } from '../../AlertModalContext'; // 1. Importar o hook de alerta
 
const initialProcedureState = {
  nome: '',
  dataHora: new Date(),
  profissional: '',
  quantidade: 1, // NOVO: Campo para quantidade
  valor_unitario: 0, // NOVO: Para armazenar o valor do serviço
  observacoes: '',
  material: '',
};

const ProntuarioComponent = ({ historico, consultaAtual, servicos, isLoading, fetchProntuarioData, onAppointmentStatusChange, onConsultaFinalizada, servicosDoAgendamento, setIsScreenLocked, isActive = true, hospitalarUnitId = null }) => {

  const {
    pacienteSelecionado,
    saveResultMessageContext, 
    setSaveResultMessageContext, 
    setIsConsultaSalva,
  } = usePacienteContext();

  const { currentEntidade } = useEntidadeContext();
  const { loggedInUser } = useAuthContext();
  const { showAlertModal } = useAlertModal(); // 2. Obter a função para mostrar o modal

  // --- INÍCIO DA CORREÇÃO: Estado local para gerenciar a consulta ---
  const [localConsultaAtual, setLocalConsultaAtual] = useState(consultaAtual);

  // Estados locais para os campos do formulário
  const [relatoConsulta, setRelatoConsulta] = useState('');
  const [observacoesConsulta, setObservacoesConsulta] = useState('');

  // --- NOVOS ESTADOS PARA ANAMNESE DIGITAL ---
  const [isAnamneseComplete, setIsAnamneseComplete] = useState(false);
  const [anamneseCode, setAnamneseCode] = useState(null);
  const [showAnamneseCodeModal, setShowAnamneseCodeModal] = useState(false);
  const [isGeneratingAnamnese, setIsGeneratingAnamnese] = useState(false);

  // NOVOS ESTADOS PARA ANAMNESE
  const [historicoDoencaAtual, setHistoricoDoencaAtual] = useState('');
  const [historicoMedicoPessoal, setHistoricoMedicoPessoal] = useState('');
  const [historicoMedicoFamiliar, setHistoricoMedicoFamiliar] = useState('');

  // NOVOS ESTADOS PARA SINAIS VITAIS
  const [pressaoArterial, setPressaoArterial] = useState('');
  const [temperatura, setTemperatura] = useState('');
  const [frequenciaCardiaca, setFrequenciaCardiaca] = useState('');
  const [saturacaoOxigenio, setSaturacaoOxigenio] = useState('');
  const [peso, setPeso] = useState('');
  const [altura, setAltura] = useState('');

  // NOVOS ESTADOS PARA PLANO CLÍNICO
  const [diagnostico, setDiagnostico] = useState('');
  const [prescricao, setPrescricao] = useState('');
  const [solicitacaoExames, setSolicitacaoExames] = useState('');
  const [planoTratamento, setPlanoTratamento] = useState('');
  const [marcarRetorno, setMarcarRetorno] = useState(false);

  // NOVOS ESTADOS PARA PROCEDIMENTOS
  // Este estado agora será a fonte de verdade para o Accordion.
  // Ele será inicializado com os serviços do agendamento.
  const [procedimentos, setProcedimentos] = useState([]); 

  const [selectedServicos, setSelectedServicos] = useState([]);
  // NOVO: Estado para o total dos procedimentos
  const [totalProcedimentos, setTotalProcedimentos] = useState(0);
  // NOVO: Estado para o desconto e total final
  const [discountPercentage, setDiscountPercentage] = useState(0);
  const [discountValue, setDiscountValue] = useState(0); // NOVO: Estado para o valor do desconto em R$
  const [totalFinalEstimado, setTotalFinalEstimado] = useState(0);

  const [fotoAntesFile, setFotoAntesFile] = useState(null);
  const [previewFotoAntes, setPreviewFotoAntes] = useState(null);
  const [fotoDepoisFile, setFotoDepoisFile] = useState(null);
  const [previewFotoDepois, setPreviewFotoDepois] = useState(null);

  // Estados para controle da UI
  const [isFormDirty, setIsFormDirty] = useState(false); // NOVO: Estado local para controlar alterações
  const [isSaving, setIsSaving] = useState(false); // NOVO: Estado local para o spinner de salvamento
  // CORREÇÃO: Define a aba 'consulta' como padrão.
  const [isSavingAndFinishing, setIsSavingAndFinishing] = useState(false); // NOVO: Para o novo botão
  const [activeView, setActiveView] = useState('consulta');
  // NOVO: Ref para controlar se os dados da consulta já foram carregados no estado local.
  // Isso evita que o useEffect popule os campos novamente a cada renderização, limpando os inputs.
  const consultaCarregadaRef = useRef(null);
  const [showImageModal, setShowImageModal] = useState(false);
  const [showSuccessTooltip, setShowSuccessTooltip] = useState(false); // NOVO: Estado para o tooltip de sucesso
  const [modalImageUrl, setModalImageUrl] = useState('');
  const [showImageOptionsMenu, setShowImageOptionsMenu] = useState(false);
  const [imageOptionsContext, setImageOptionsContext] = useState({ type: null, url: null });

  // NOVO: Estados para o modal de adicionar serviço
  const [showAddServiceModal, setShowAddServiceModal] = useState(false);
  const [servicesToAdd, setServicesToAdd] = useState(new Set());
  const [isAddingServices, setIsAddingServices] = useState(false);
  // NOVO: Estados para pacotes de sessões do paciente
  const [pacientePacotesAtivos, setPacientePacotesAtivos] = useState([]);
  const [isLoadingPacotes, setIsLoadingPacotes] = useState(false);

  // Estados e Refs para a câmera
  const [showCameraModal, setShowCameraModal] = useState(false);
  const [cameraStream, setCameraStream] = useState(null);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const streamRef = useRef(null);
  const [capturingFor, setCapturingFor] = useState(null);
  const [videoDevices, setVideoDevices] = useState([]);
  const [activeDeviceId, setActiveDeviceId] = useState(null);
  const [isSwitchingCamera, setIsSwitchingCamera] = useState(false);

  // NOVO: Estado para controlar a visibilidade das abas do prontuário
  const [prontuarioTabsConfig, setProntuarioTabsConfig] = useState({
    atestado: false,
    receituario: false,
    documentos: false,
    laudos: false,
    documentosConsulta: false, // NOVO: Para a aba de documentos da consulta
    assinatura: false,        // NOVO: Para a aba de assinatura
  });

  // Verifica se o paciente já possui anamneses registradas para ocultar o botão de solicitação
  useEffect(() => {
    const checkExistingAnamnese = async () => {
      if (!isActive || !pacienteSelecionado?.id) return;
      setIsAnamneseComplete(false); // Reset ao trocar de paciente no prontuário
      try {
        const response = await axios.get(`/api/anamneses?paciente_id=${pacienteSelecionado.id}`);
        if (response.data.anamneses && response.data.anamneses.length > 0) {
          setIsAnamneseComplete(true);
        }
      } catch (error) {
        console.error("Erro ao verificar anamneses existentes:", error);
      }
    };
    checkExistingAnamnese();
  }, [isActive, pacienteSelecionado?.id]);

  // --- POLLING PARA VERIFICAR STATUS DA ANAMNESE ---
  useEffect(() => {
    let interval;
    if (showAnamneseCodeModal && anamneseCode) {
      interval = setInterval(async () => {
        try {
          const response = await axios.get(`/api/anamnese/status/${anamneseCode}`);
          if (response.data.status === 'preenchido') {
            setIsAnamneseComplete(true);
            setShowAnamneseCodeModal(false);
            // Opcional: Você pode disparar um fetch aqui para atualizar a aba 'anamnese_view'
            clearInterval(interval);
          }
        } catch (error) {
          console.error("Erro ao verificar status da anamnese:", error);
        }
      }, 3000); // Verifica a cada 3 segundos
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [showAnamneseCodeModal, anamneseCode]);

  // Memo para formatar os serviços para o react-select
  const servicoOptions = useMemo(() =>
    (servicos || []).map(s => ({ value: s.nome, label: s.nome })),
  [servicos]);

  // NOVO: useEffect para calcular o total sempre que os procedimentos mudarem
  useEffect(() => {
    const calcularTotais = () => {
      // Para uma busca eficiente, mapeia o nome do serviço para seu objeto completo.
      const servicosMap = new Map(servicos.map(s => [s.nome, s]));

      const subtotal = procedimentos.reduce((acc, proc) => {
        const servicoCompleto = servicosMap.get(proc.nome);

        // Se o serviço não for encontrado ou não for um serviço de pacote, soma o valor normalmente.
        if (!servicoCompleto || servicoCompleto.numero_sessoes <= 1) {
          return acc + (proc.valor_unitario * (proc.quantidade || 1));
        }

        // Se for um serviço de pacote, verifica se já existe um pacote ativo para ele.
        const pacoteAtivoExistente = pacientePacotesAtivos.some(
          pacote => pacote.servico_id === servicoCompleto.id
        );

        // Se já existe um pacote ativo, é apenas consumo, então o valor é zero.
        // Caso contrário, é uma nova contratação, então o valor é somado.
        return pacoteAtivoExistente ? acc : acc + (proc.valor_unitario * (proc.quantidade || 1));
      }, 0);

      setTotalProcedimentos(subtotal);

      // Calcula o valor final com o desconto aplicado
      const valorDesconto = subtotal * (discountPercentage / 100);
      setDiscountValue(valorDesconto); // NOVO: Armazena o valor do desconto
      const final = subtotal - valorDesconto;
      setTotalFinalEstimado(final);
    };
    calcularTotais();
  }, [procedimentos, discountPercentage, servicos, pacientePacotesAtivos]); // Adiciona as novas dependências

  // NOVO: Efeito dedicado a resetar a configuração das abas apenas quando a consulta muda.
  useEffect(() => {
    setProntuarioTabsConfig({
      atestado: false,
      receituario: false,
      documentos: false,
      laudos: false,
      documentosConsulta: false,
      assinatura: false,
    });
  }, [localConsultaAtual?.id]); // Dependência super específica para evitar resets indesejados.

  // --- CORREÇÃO: Sincroniza o estado local com a prop quando ela muda (ex: novo paciente) ---
  useEffect(() => {
    setLocalConsultaAtual(consultaAtual);
  }, [consultaAtual]);

  // --- CORREÇÃO: Busca os pacotes ativos sempre que o paciente em consulta mudar ---
  useEffect(() => {
    const fetchPacotesAtivosDoPaciente = async () => {
      if (isActive && pacienteSelecionado?.id) {
        setIsLoadingPacotes(true);
        try {
          const response = await axios.get(`/api/pacientes/${pacienteSelecionado.id}/pacotes-ativos`);
          setPacientePacotesAtivos(response.data.pacotes_ativos || []);
        } catch (error) {
          console.error("Erro ao buscar pacotes ativos do paciente no prontuário:", error);
          setPacientePacotesAtivos([]);
        } finally {
          setIsLoadingPacotes(false);
        }
      } else {
        // Se não há paciente, limpa a lista de pacotes.
        setPacientePacotesAtivos([]);
      }
    };
    fetchPacotesAtivosDoPaciente();
  }, [isActive, pacienteSelecionado?.id]); // Abas inativas não disputam carregamentos em segundo plano.

  useEffect(() => {
    // Se não há consulta atual, reseta tudo e marca que os dados precisam ser carregados na próxima vez.

    if (!localConsultaAtual) {
      // Limpa todos os estados do formulário
      setProcedimentos([initialProcedureState]);
      setRelatoConsulta(''); setObservacoesConsulta(''); setHistoricoDoencaAtual('');
      setHistoricoMedicoPessoal(''); setHistoricoMedicoFamiliar(''); setPressaoArterial('');
      setTemperatura(''); setFrequenciaCardiaca(''); setSaturacaoOxigenio('');
      setPeso(''); setAltura(''); setDiagnostico(''); setPrescricao('');
      setSolicitacaoExames(''); setPlanoTratamento(''); setMarcarRetorno(false);
      setPreviewFotoAntes(null); setPreviewFotoDepois(null);
      consultaCarregadaRef.current = null; // Permite carregar dados para a próxima consulta
      return;
    }

    // **CORREÇÃO PRINCIPAL**: Apenas popula os campos se a consulta atual (pelo ID) for diferente da que já foi carregada.
    // Isso impede que o estado seja sobrescrito a cada re-renderização (ex: ao digitar em um input).
    // --- CORREÇÃO: Compara também o `updated_at` para forçar a atualização após salvar ---
    const isSameConsultation = consultaCarregadaRef.current?.id === localConsultaAtual.id;
    const isSameVersion = consultaCarregadaRef.current?.updated_at === localConsultaAtual.updated_at;
    if (isSameConsultation && isSameVersion) {
      return;
    }

    // Apenas executa a lógica de popular o formulário se os dados essenciais estiverem prontos.
    if ((Array.isArray(servicosDoAgendamento) && servicosDoAgendamento.length > 0) || (localConsultaAtual && (localConsultaAtual.isNew || localConsultaAtual.procedimentos))) {
      // Popula os campos de texto do formulário
      setRelatoConsulta(localConsultaAtual.queixa_principal || '');
      setObservacoesConsulta(localConsultaAtual.observacoes || '');
      setHistoricoDoencaAtual(localConsultaAtual.historico_doenca_atual || '');
      setHistoricoMedicoPessoal(localConsultaAtual.historico_medico_pessoal || '');
      setHistoricoMedicoFamiliar(localConsultaAtual.historico_medico_familiar || '');
      setPressaoArterial(localConsultaAtual.pressao_arterial || '');
      setTemperatura(localConsultaAtual.temperatura || '');
      setFrequenciaCardiaca(localConsultaAtual.frequencia_cardiaca || '');
      setSaturacaoOxigenio(localConsultaAtual.saturacao_oxigenio || '');
      setPeso(localConsultaAtual.peso || '');
      setAltura(localConsultaAtual.altura || '');
      setDiagnostico(localConsultaAtual.diagnostico || '');
      setPrescricao(localConsultaAtual.prescricao || '');
      setSolicitacaoExames(localConsultaAtual.solicitacao_exames || '');
      setPlanoTratamento(localConsultaAtual.plano_tratamento || '');
      setMarcarRetorno(localConsultaAtual.marcar_retorno || false);
      setPreviewFotoAntes(localConsultaAtual.foto_path_antes ? `${config.apiBaseURL}/storage/entidade/${currentEntidade.id}/fotos_pacientes/${localConsultaAtual.foto_path_antes}` : null);
      setPreviewFotoDepois(localConsultaAtual.foto_path_depois ? `${config.apiBaseURL}/storage/entidade/${currentEntidade.id}/fotos_pacientes/${localConsultaAtual.foto_path_depois}` : null);

      // Popula a lista de procedimentos
      let procedimentosSalvos = [];
      if (localConsultaAtual.procedimentos) {
        try {
          const parsed = Array.isArray(localConsultaAtual.procedimentos) ? localConsultaAtual.procedimentos : JSON.parse(localConsultaAtual.procedimentos);
          procedimentosSalvos = Array.isArray(parsed) ? parsed : [];
        } catch (e) {
          console.error("Erro ao parsear procedimentos:", e);
        }
      }

      const servicosAgendamentoArr = Array.isArray(servicosDoAgendamento) ? servicosDoAgendamento : [];

      // 1. Mapeia serviços do agendamento (prioridade para dados salvos se existirem)
      const procedimentosDoAgendamento = servicosAgendamentoArr.map(servico => {
        const procedimentoSalvo = procedimentosSalvos.find(p => p.nome === servico.nome);
        return procedimentoSalvo
          ? { ...procedimentoSalvo, dataHora: procedimentoSalvo.dataHora ? new Date(procedimentoSalvo.dataHora) : new Date() }
          : {
              ...initialProcedureState,
              nome: servico.nome,
              profissional: loggedInUser?.nome || '',
              valor_unitario: parseFloat(servico.valor || 0),
              quantidade: 1,
              material: servico.materiais?.map(m => `${m.nome} (${m.pivot.quantidade_utilizada} ${m.tipo_material?.unidade_medida || 'unid.'})`).join('\n') || ''
            };
      });

      // 2. Adiciona procedimentos salvos que NÃO estão no agendamento (adicionados manualmente)
      const nomesNoAgendamento = new Set(servicosAgendamentoArr.map(s => s.nome));
      const procedimentosExtras = procedimentosSalvos
        .filter(p => !nomesNoAgendamento.has(p.nome))
        .map(p => ({
          ...p,
          dataHora: p.dataHora ? new Date(p.dataHora) : new Date()
        }));

      const listaFinal = [...procedimentosDoAgendamento, ...procedimentosExtras];
      setProcedimentos(listaFinal.length > 0 ? listaFinal : [initialProcedureState]);

      // Marca que os dados para esta consulta já foram carregados no estado.
      consultaCarregadaRef.current = {
        id: localConsultaAtual.id,
        updated_at: localConsultaAtual.updated_at,
      };
    } // A dependência de `todosOsServicos` foi removida pois não é mais necessária aqui.
  },[localConsultaAtual, loggedInUser?.nome, initialProcedureState, currentEntidade.id, servicosDoAgendamento]);

  // --- Handlers para Procedimentos ---
  const handleProcedimentoChange = (index, field, value) => {
    const newProcedimentos = [...procedimentos];
    newProcedimentos[index][field] = value;
  
    // Se o campo alterado for o nome do procedimento, busca os materiais do serviço
    if (field === 'nome') {
      const servicoSelecionado = servicos.find(s => s.nome === value);
  
      // NOVO: Atualiza o valor unitário do procedimento
      newProcedimentos[index].valor_unitario = servicoSelecionado ? parseFloat(servicoSelecionado.valor || 0) : 0;
  
      if (servicoSelecionado && servicoSelecionado.materiais?.length > 0) {
        // Formata a lista de materiais para exibição no textarea
        const materialString = servicoSelecionado.materiais
          .map(material => {
            const quantidade = material.pivot?.quantidade_utilizada || 0;
            const unidade = material.tipo_material?.unidade_medida || 'unid.';
            return `${material.nome} (${quantidade} ${unidade})`;
          })
          .join('\n'); // Usa \n para quebra de linha no textarea
  
        newProcedimentos[index].material = materialString;
      } else {
        // Se for um procedimento customizado ou um serviço sem materiais, limpa o campo
        newProcedimentos[index].material = '';
      }
    }
  
    setProcedimentos(newProcedimentos);
    setIsFormDirty(true);
  };

  const handleRemoveProcedimento = (index) => {
    if (procedimentos.length <= 1) return; // Não permite remover o último
    const newProcedimentos = [...procedimentos];
    newProcedimentos.splice(index, 1);
    setProcedimentos(newProcedimentos);
    setIsFormDirty(true);
  };

  // NOVO: Handler para alterar a visibilidade das abas
  const handleTabConfigChange = (tabKey) => {
    setProntuarioTabsConfig(prev => ({ ...prev, [tabKey]: !prev[tabKey] }));
  };


  // Função para salvar a consulta (agora local)
  const saveConsultaData = async () => {
    if (!pacienteSelecionado?.agendamento_id || !currentEntidade) {
      setSaveResultMessageContext({ type: 'danger', text: 'Informações do paciente, agendamento ou entidade ausentes.' });
      return false;
    }
    if (!relatoConsulta.trim()) {
      setSaveResultMessageContext({ type: 'danger', text: 'O campo "Queixa Principal" é obrigatório.' });
      return false;
    }

    setSaveResultMessageContext(null);

    const formData = new FormData();
    // Preenche o formData... (lógica idêntica à anterior)
    formData.append('entidade_id', currentEntidade.id);
    // Adiciona o prontuario_id se estiver disponível no paciente selecionado
    if (pacienteSelecionado?.prontuario_id) {
      formData.append('prontuario_id', pacienteSelecionado.prontuario_id);
    }
    formData.append('queixa_principal', relatoConsulta);
    formData.append('observacoes', observacoesConsulta);
    formData.append('historico_doenca_atual', historicoDoencaAtual);
    formData.append('historico_medico_pessoal', historicoMedicoPessoal);
    formData.append('historico_medico_familiar', historicoMedicoFamiliar);
    formData.append('pressao_arterial', pressaoArterial);
    formData.append('temperatura', temperatura);
    formData.append('frequencia_cardiaca', frequenciaCardiaca);
    formData.append('saturacao_oxigenio', saturacaoOxigenio);
    formData.append('peso', peso);
    formData.append('altura', altura);
    formData.append('diagnostico', diagnostico);
    formData.append('prescricao', prescricao);
    formData.append('solicitacao_exames', solicitacaoExames);
    formData.append('plano_tratamento', planoTratamento);
    formData.append('marcar_retorno', marcarRetorno ? 1 : 0);
    formData.append('procedimentos', JSON.stringify(procedimentos));

    // --- Incluindo os serviços adicionados em procedimentos ---
    // O objetivo é enviar um array de IDs de serviços para o backend.
    // 1. Criamos um Map para uma busca eficiente de ID por nome de serviço.
    const servicoNomeParaIdMap = new Map(servicos.map(s => [s.nome, s.id]));

    // 2. Extraímos os nomes dos procedimentos que estão sendo registrados na consulta.
    const nomesDosProcedimentos = procedimentos.map(p => p.nome);

    // 3. Mapeamos os nomes de volta para seus IDs, filtrando qualquer um que não seja encontrado (ex: procedimentos customizados).
    const servicoIds = nomesDosProcedimentos
      .map(nome => servicoNomeParaIdMap.get(nome))
      .filter(id => id != null); // Garante que apenas IDs válidos sejam enviados.

    // 4. Adicionamos cada ID ao FormData no formato de array esperado pelo PHP/Laravel.
    servicoIds.forEach(id => formData.append('servicos[]', id));
    // --- FIM inclusão de serviços ---

    selectedServicos.forEach(id => formData.append('servicos[]', id));
    if (fotoAntesFile) formData.append('foto_antes', fotoAntesFile);
    if (fotoDepoisFile) formData.append('foto_depois', fotoDepoisFile);
    formData.append('_method', 'PUT');


    try {
      const response = await axios.post(`/api/consultas/${pacienteSelecionado.agendamento_id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      if (response.status === 200) {
        setIsFormDirty(false);
        if (response.data.stock_pending_count > 0) {
          setSaveResultMessageContext({ type: 'warning', text: response.data.message });
          showAlertModal('Pendência de estoque', response.data.message, 'warning');
        }
        // --- CORREÇÃO: Usa o novo callback onConsultaSaved ---
        // Notifica o pai para atualizar APENAS os dados da consulta, sem mexer no status do agendamento.
        // if (onConsultaSaved) {
        //   console.log('[pronturario]response.data.consulta', response.data.consulta);
        //   onConsultaSaved(response.data.consulta);
        // }
        // setIsConsultaSalva(true);
        // Opcional: Atualizar estado local com dados retornados se necessário
        return true; // Sucesso
      }
      setSaveResultMessageContext({ type: 'danger', text: 'Erro ao salvar consulta.' });
      return false; // Falha
    } catch (error) {
      console.error("Erro ao salvar consulta:", error);
      setSaveResultMessageContext({ type: 'danger', text: `Erro ao salvar: ${error.response?.data?.message || error.message}` });
      return false; // Falha
    }
  };

  // --- NOVO: Lógica para Adicionar Serviços ---
  const handleOpenAddServiceModal = () => {
    // Limpa seleções anteriores ao abrir o modal
    setServicesToAdd(new Set());
    setShowAddServiceModal(true);
  };

  const handleToggleServiceToAdd = (serviceId) => {
    setServicesToAdd(prev => {
      const newSet = new Set(prev);
      if (newSet.has(serviceId)) {
        newSet.delete(serviceId);
      } else {
        newSet.add(serviceId);
      }
      return newSet;
    });
  };

  // --- FUNÇÃO REFATORADA ---
  // Agora, apenas atualiza o estado local, sem chamada à API.
  const handleConfirmAddServices = () => {
    if (servicesToAdd.size === 0) {
      showAlertModal('Atenção', 'Nenhum serviço foi selecionado.', 'warning');
      return;
    }

    // Encontra os objetos completos dos serviços selecionados
    const servicosParaAdicionar = servicos.filter(s => servicesToAdd.has(s.id));

    // Formata os novos serviços como objetos de procedimento
    const novosProcedimentos = servicosParaAdicionar.map(servico => ({
      ...initialProcedureState,
      nome: servico.nome,
      valor_unitario: parseFloat(servico.valor || 0),
      profissional: loggedInUser?.nome || '',
      material: servico.materiais?.map(m => `${m.nome} (${m.pivot.quantidade_utilizada} ${m.tipo_material?.unidade_medida || 'unid.'})`).join('\n') || ''
    }));

    // Adiciona os novos procedimentos à lista existente, evitando duplicatas pelo nome
    setProcedimentos(prevProcedimentos => {
      const nomesExistentes = new Set(prevProcedimentos.map(p => p.nome));
      const procedimentosFiltrados = novosProcedimentos.filter(p => !nomesExistentes.has(p.nome));
      return [...prevProcedimentos, ...procedimentosFiltrados];
    });

    // Atualiza o estado dos serviços selecionados para adicionar os novos
    // Isso é importante para a lógica de desabilitar opções já adicionadas
    setSelectedServicos(prevSelected => {
      const newSelected = new Set([...prevSelected, ...servicosParaAdicionar.map(s => s.id)]);
      return Array.from(newSelected);
    });

    setIsFormDirty(true); // Marca o formulário como alterado
    setShowAddServiceModal(false); // Fecha o modal
  };

  // Função para gerar o código da anamnese para o tablet
  const handleGenerateAnamneseCode = async () => {
    setIsGeneratingAnamnese(true);
    try {
      const response = await axios.post('/api/anamnese/gerar-codigo', { 
        agendamento_id: pacienteSelecionado.agendamento_id 
      });
      setAnamneseCode(response.data.codigo);
      setShowAnamneseCodeModal(true);
    } catch (error) {
        showAlertModal('Erro', 'Não foi possível gerar o código da anamnese.', 'danger');
    } finally {
      setIsGeneratingAnamnese(false);
    }
  };

  // --- Lógica da Câmera ---
  const stopCameraStream = useCallback(() => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach(track => track.stop());
      streamRef.current = null;
    }
    setCameraStream(null);
  }, []);

  const handleCloseCamera = useCallback(() => {
    stopCameraStream();
    setShowCameraModal(false);
  }, [stopCameraStream]);

  const handleOpenCamera = useCallback(async (tipoFoto) => {
    setCapturingFor(tipoFoto);
    setShowCameraModal(true);
    try {
      const preliminaryStream = await navigator.mediaDevices.getUserMedia({ video: true });
      preliminaryStream.getTracks().forEach(track => track.stop());
      const devices = await navigator.mediaDevices.enumerateDevices();
      const videoInputs = devices.filter(device => device.kind === 'videoinput');
      if (videoInputs.length === 0) {
        alert("Nenhuma câmera foi encontrada.");
        handleCloseCamera();
        return;
      }
      setVideoDevices(videoInputs);
      let defaultCamera = videoInputs.find(device => /back|traseira/i.test(device.label)) || videoInputs[videoInputs.length - 1];
      setActiveDeviceId(defaultCamera ? defaultCamera.deviceId : videoInputs[0].deviceId);
    } catch (err) {
      alert("Não foi possível acessar a câmera. Verifique as permissões do navegador.");
      handleCloseCamera();
    }
  }, [handleCloseCamera]);

  const startCameraStream = useCallback(async (deviceId) => {
    stopCameraStream();
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: { deviceId: { exact: deviceId } } });
      streamRef.current = stream;
      setCameraStream(stream);
    } catch (err) {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: { deviceId } });
        streamRef.current = stream;
        setCameraStream(stream);
      } catch (fallbackErr) {
        alert("Não foi possível acessar a câmera selecionada.");
      }
    }
  }, [stopCameraStream]);

  useEffect(() => {
    if (cameraStream && videoRef.current) videoRef.current.srcObject = cameraStream;
    else if (videoRef.current) videoRef.current.srcObject = null;
  }, [cameraStream]);

  useEffect(() => {
    if (activeDeviceId) startCameraStream(activeDeviceId);
  }, [activeDeviceId, startCameraStream]);

  const handleSwitchCamera = useCallback(() => {
    setIsSwitchingCamera(true);
    const currentIndex = videoDevices.findIndex(device => device.deviceId === activeDeviceId);
    const nextIndex = (currentIndex + 1) % videoDevices.length;
    setActiveDeviceId(videoDevices[nextIndex].deviceId);
    setTimeout(() => setIsSwitchingCamera(false), 500);
  }, [activeDeviceId, videoDevices]);

  const handleCapturePhoto = useCallback(() => {
    if (!videoRef.current || !canvasRef.current) return;
    const video = videoRef.current;
    const canvas = canvasRef.current;
    const context = canvas.getContext('2d');
    canvas.width = 300; canvas.height = 400;
    const videoAspectRatio = video.videoWidth / video.videoHeight;
    const canvasAspectRatio = canvas.width / canvas.height;
    let sx = 0, sy = 0, sWidth = video.videoWidth, sHeight = video.videoHeight;
    if (videoAspectRatio > canvasAspectRatio) { sWidth = video.videoHeight * canvasAspectRatio; sx = (video.videoWidth - sWidth) / 2; } 
    else { sHeight = video.videoWidth / canvasAspectRatio; sy = (video.videoHeight - sHeight) / 2; }
    context.drawImage(video, sx, sy, sWidth, sHeight, 0, 0, canvas.width, canvas.height);
    canvas.toBlob(blob => {
      if (capturingFor === 'antes') { setFotoAntesFile(blob); setPreviewFotoAntes(URL.createObjectURL(blob)); } 
      else if (capturingFor === 'depois') { setFotoDepoisFile(blob); setPreviewFotoDepois(URL.createObjectURL(blob)); }
      setIsFormDirty(true); // Marca o formulário como alterado
      handleCloseCamera();
    }, 'image/jpeg', 0.9);
  }, [capturingFor, handleCloseCamera]);

  
// Função para calcular a duração da consulta
  const calcularDuracao = (startTime, endTime) => {
    const diffMs = endTime - startTime;
    const diffSecs = Math.round(diffMs / 1000);
    const hours = Math.floor(diffSecs / 3600).toString().padStart(2, '0');
    const minutes = Math.floor((diffSecs % 3600) / 60).toString().padStart(2, '0');
    const seconds = Math.floor((diffSecs % 60)).toString().padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  }

  // NOVO: Função para salvar e finalizar
  const handleSaveAndFinish = async () => {
    // --- INÍCIO DA CORREÇÃO ---
    setIsScreenLocked(true); // Ativa o bloqueio da tela
    // --- FIM DA CORREÇÃO ---
    setIsSavingAndFinishing(true);
    const saved = await saveConsultaData();

    if (saved) {
      try {
        const startTime = new Date(pacienteSelecionado.agendamento_updated_at);
        const endTime = new Date();
        const duration = calcularDuracao(startTime, endTime);

        const payload = { status: 'Realizada', duracao_atendimento: duration };
        await axios.put(`/api/agendamentos/${pacienteSelecionado.agendamento_id}`, payload);

        // Notifica o componente pai para limpar o paciente e atualizar a agenda
        onConsultaFinalizada();

      } catch (error) {
        showAlertModal('Erro', `A consulta foi salva, mas ocorreu um erro ao finalizar: ${error.response?.data?.message || error.message}`, 'danger');
      }
    }
    // Se o salvamento falhar, a mensagem de erro já é exibida por saveConsultaData
    // --- INÍCIO DA CORREÇÃO ---
    setIsSavingAndFinishing(false);
    setIsScreenLocked(false); // Garante que o bloqueio seja removido em qualquer cenário
    // --- FIM DA CORREÇÃO ---
  };

  // --- Handlers ---
  const handleServicoChange = (servicoId) => {
    setSelectedServicos(prev => {
      const newSelected = prev.includes(servicoId) ? prev.filter(id => id !== servicoId) : [...prev, servicoId];
      return newSelected;
    });
    setIsFormDirty(true); // Marca o formulário como alterado
  };

  const handleOpenImageModal = (imageUrl) => { setModalImageUrl(imageUrl); setShowImageModal(true); };
  const handleCloseImageModal = () => setShowImageModal(false);
  const handlePreviewClick = (type, url) => {
    if (!url) return;
    setImageOptionsContext({ type, url });
    setShowImageOptionsMenu(true);
  };

  // NOVO: Função para mudar a visualização e buscar dados se necessário
  const handleViewChange = useCallback((view) => {
    setActiveView(view);
    // Se o usuário clicar no histórico, força a busca para garantir que os dados estão atualizados.
    if (view === 'historico' && pacienteSelecionado) {
      fetchProntuarioData(pacienteSelecionado, { force: true });
    }
  }, [pacienteSelecionado, fetchProntuarioData]);

  // Função para salvar a consulta (agora local)
  const handleSalvarConsulta = async () => {
    setIsScreenLocked(true); // Ativa o bloqueio de tela
    setIsSaving(true); // Usa o spinner local
    try {
      const saved = await saveConsultaData();
      if (saved) {
        // Em vez de usar o alerta, ativamos o tooltip
        setShowSuccessTooltip(true);
        // E escondemos o tooltip após alguns segundos
        setTimeout(() => {
          setShowSuccessTooltip(false);
        }, 3000);
      }
    } finally {
      setIsSaving(false); // Para o spinner local
      setIsScreenLocked(false); // Garante que o bloqueio seja removido
    }
  };

  if (isLoading) {
    return (
      <div className="text-center my-5">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Carregando...</span>
        </Spinner>
      </div>
    );
  }

  if (!pacienteSelecionado) {
    return (
      <Card>
        <Card.Body>
          <Placeholder as="p" animation="glow"><Placeholder xs={6} /></Placeholder>
          <p>Selecione um paciente na aba "Agenda" para iniciar ou ver um prontuário.</p>
        </Card.Body>
      </Card>
    );
  }

  return (
    <TelehealthWorkspace consultation appointmentId={consultaAtual?.agendamento_id || consultaAtual?.agendamento?.id || pacienteSelecionado?.agendamento_id}>
    <Container fluid className="p-0">
      <Row>
        {/* Sidebar de Navegação */}
        <Col md={1} lg={1} className="prontuario-sidebar bg-light p-2">
          <Nav variant="pills" className="flex-column">
            {consultaAtual && (
              <Nav.Item>
                <Nav.Link onClick={() => handleViewChange('consulta')} active={activeView === 'consulta'} className="d-flex flex-column align-items-center p-2 mb-2" title="Consulta Atual">
                  <FontAwesomeIcon icon={faStethoscope} size="2x" />
                  <span className="mt-1" style={{ fontSize: '0.7rem' }}>Consulta</span>
                </Nav.Link>
              </Nav.Item>
            )}
            <Nav.Item>
              <Nav.Link onClick={() => handleViewChange('historico')} active={activeView === 'historico'} className="d-flex flex-column align-items-center p-2 mb-2" title="Histórico de Relatos">
                <FontAwesomeIcon icon={faHistory} size="2x" />
                <span className="mt-1" style={{ fontSize: '0.7rem' }}>Histórico</span>
              </Nav.Link>
            </Nav.Item>            
            <Nav.Item>
              <Nav.Link onClick={() => handleViewChange('anamnese_view')} active={activeView === 'anamnese_view'} className="d-flex flex-column align-items-center p-2 mb-2" title="Anamnese preenchida">
                <FontAwesomeIcon icon={faClipboardList} size="2x" />
                <span className="mt-1" style={{ fontSize: '0.7rem' }}>Anamnese</span>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link onClick={() => setActiveView('alergias')} active={activeView === 'alergias'} className="d-flex flex-column align-items-center p-2 mb-2" title="Alergias do Paciente">
                <FontAwesomeIcon icon={faExclamationTriangle} size="2x" className="text-danger" />
                <span className="mt-1" style={{ fontSize: '0.7rem' }}>Alergias</span>
              </Nav.Link>
            </Nav.Item>

            {/* Abas Condicionais - Agora usam o estado 'prontuarioTabsConfig' */}
            {prontuarioTabsConfig.laudos && (
              <Nav.Item>
                <Nav.Link onClick={() => setActiveView('laudos')} active={activeView === 'laudos'} className="d-flex flex-column align-items-center p-2 mb-2" title="Laudos e Exames">
                  <FontAwesomeIcon icon={faFileWaveform} size="2x" />
                  <span className="mt-1" style={{ fontSize: '0.7rem' }}>Laudos</span>
                </Nav.Link>
              </Nav.Item>
            )}

            {prontuarioTabsConfig.documentos && (
              <Nav.Item>
                <Nav.Link onClick={() => setActiveView('documentos_historico')} active={activeView === 'documentos_historico'} className="d-flex flex-column align-items-center p-2 mb-2" title="Histórico de Documentos">
                  <FontAwesomeIcon icon={faFolderOpen} size="2x" />
                  <span className="mt-1" style={{ fontSize: '0.7rem' }}>Docs</span>
                </Nav.Link>
              </Nav.Item>
            )}

            {/* ÍCONES DE RECEITUÁRIO E ATESTADO MOVIDOS PARA O FINAL */}
            {consultaAtual && (
              <>
                {prontuarioTabsConfig.receituario && (
                  <Nav.Item>
                    <Nav.Link onClick={() => setActiveView('receituario')} active={activeView === 'receituario'} className="d-flex flex-column align-items-center p-2 mb-2" title="Gerar Receituário">
                      <FontAwesomeIcon icon={faFilePrescription} size="2x" />
                      <span className="mt-1" style={{ fontSize: '0.7rem' }}>Receituário</span>
                    </Nav.Link>
                  </Nav.Item>
                )}
                {prontuarioTabsConfig.atestado && (
                  <Nav.Item>
                    <Nav.Link onClick={() => setActiveView('atestado')} active={activeView === 'atestado'} className="d-flex flex-column align-items-center p-2 mb-2" title="Gerar Atestado">
                      <FontAwesomeIcon icon={faFileMedical} size="2x" />
                      <span className="mt-1" style={{ fontSize: '0.7rem' }}>Atestado</span>
                    </Nav.Link>
                  </Nav.Item>
                )}
              </>
            )}
          </Nav>
        </Col>

        {/* Conteúdo Principal */}
        <Col md={11} lg={11} className="prontuario-content">
          {hospitalarUnitId&&(pacienteSelecionado?.agendamento_id||localConsultaAtual?.agendamento_id)&&<HospitalarLegacyClinicalBridge key={`${hospitalarUnitId}:${pacienteSelecionado?.agendamento_id||localConsultaAtual?.agendamento_id}`} unitId={hospitalarUnitId} appointmentId={pacienteSelecionado?.agendamento_id||localConsultaAtual?.agendamento_id}/>}
          {activeView === 'consulta' && consultaAtual && (
            <div id="consulta-atual-view">
              {/* NOVO: Card para habilitar/desabilitar abas */}
              <Card>
                {saveResultMessageContext ? (
                  <Alert variant={saveResultMessageContext.type} className="m-0">{saveResultMessageContext.text}</Alert>
                ) : (
                  <Card.Header>Consulta atual do Paciente</Card.Header>
                )}
                <Card.Body>
                  <Tabs defaultActiveKey="atendimento" id="consulta-tabs" className="mb-3 nav-fill">
                    <Tab mountOnEnter unmountOnExit eventKey="integrado" title="Histórico integrado"><SharedClinicalHistoryTab key={pacienteSelecionado?.id} patientId={pacienteSelecionado?.id} /></Tab>
                    {/* NOVA ABA UNIFICADA */}
                    <Tab eventKey="atendimento" title={<><FontAwesomeIcon icon={faNotesMedical} className="me-2" />Atendimento</>}>
                      <Card className="mb-3">
                        <Card.Header as="h5" className="bg-primary bg-opacity-10"><FontAwesomeIcon icon={faHeartbeat} className="me-2" />Sinais Vitais e Exame Físico</Card.Header>
                        <Card.Body>
                      <Form>
                        <Row>
                          <Col md={2}><Form.Group className="mb-3" controlId="pressaoArterial"><Form.Label>Pressão Arterial</Form.Label><Form.Control type="text" value={pressaoArterial} onChange={(e) => { setPressaoArterial(e.target.value); setIsFormDirty(true); }} /></Form.Group></Col>
                          <Col md={2}><Form.Group className="mb-3" controlId="temperatura"><Form.Label>Temperatura (°C)</Form.Label><Form.Control type="text" value={temperatura} onChange={(e) => { setTemperatura(e.target.value); setIsFormDirty(true); }} /></Form.Group></Col>
                          <Col md={2}><Form.Group className="mb-3" controlId="frequenciaCardiaca"><Form.Label>Freq. Cardíaca (bpm)</Form.Label><Form.Control type="text" value={frequenciaCardiaca} onChange={(e) => { setFrequenciaCardiaca(e.target.value); setIsFormDirty(true); }} /></Form.Group></Col>
                          <Col md={2}><Form.Group className="mb-3" controlId="saturacaoOxigenio"><Form.Label>Saturação O₂ (%)</Form.Label><Form.Control type="text" value={saturacaoOxigenio} onChange={(e) => { setSaturacaoOxigenio(e.target.value); setIsFormDirty(true); }} /></Form.Group></Col>
                          <Col md={2}><Form.Group className="mb-3" controlId="peso"><Form.Label>Peso (kg)</Form.Label><Form.Control type="text" value={peso} onChange={(e) => { setPeso(e.target.value); setIsFormDirty(true); }} /></Form.Group></Col>
                          <Col md={2}><Form.Group className="mb-3" controlId="altura"><Form.Label>Altura (m)</Form.Label><Form.Control type="text" value={altura} onChange={(e) => { setAltura(e.target.value); setIsFormDirty(true); }} /></Form.Group></Col>
                        </Row>
                        
                      </Form>
                        </Card.Body>
                      </Card>

                      <Card className="mb-3">
                        <Card.Header as="h5" className="bg-primary bg-opacity-10 d-flex justify-content-between align-items-center">
                          <div><FontAwesomeIcon icon={faNotesMedical} className="me-2" />Anamnese</div>
                          <div>
                            {isAnamneseComplete ? (
                                <Badge bg="success"><FontAwesomeIcon icon={faCheckCircle} className="me-1"/> Ficha Preenchida</Badge>
                            ) : (
                                <Button variant="primary" size="sm" onClick={handleGenerateAnamneseCode} disabled={isGeneratingAnamnese}>
                                    {isGeneratingAnamnese ? <Spinner size="sm" className="me-1" /> : <FontAwesomeIcon icon={faTabletAlt} className="me-1" />}
                                    Solicitar Preenchimento Digital
                                </Button>
                            )}
                          </div>
                        </Card.Header>
                        <Card.Body>
                          <Form>
                            <Row>
                              <Col md={4}>
                                <Form.Group className={`mb-3 p-2 rounded ${!relatoConsulta.trim() ? 'bg-warning-subtle' : ''}`} controlId="relatoConsulta">
                                  <Form.Label>Queixa Principal: *</Form.Label>
                                  <Form.Control as="textarea" rows={3} value={relatoConsulta} onChange={(e) => { setRelatoConsulta(e.target.value); setIsFormDirty(true); }} required />
                                </Form.Group>
                              </Col>
                              <Col md={4}>
                                <Form.Group className="mb-3" controlId="historicoDoencaAtual">
                                  <Form.Label>Histórico da Doença Atual:</Form.Label>
                                  <Form.Control as="textarea" rows={3} value={historicoDoencaAtual} onChange={(e) => { setHistoricoDoencaAtual(e.target.value); setIsFormDirty(true); }} />
                                </Form.Group>
                              </Col>
                              <Col md={4}>
                                <Form.Group className="mb-3" controlId="historicoMedicoPessoal">
                                  <Form.Label>Histórico Médico Pessoal:</Form.Label>
                                  <Form.Control as="textarea" rows={3} value={historicoMedicoPessoal} onChange={(e) => { setHistoricoMedicoPessoal(e.target.value); setIsFormDirty(true); }} />
                                </Form.Group>
                              </Col>
                              <Col md={5}>
                                <Form.Group className="mb-3" controlId="historicoMedicoFamiliar">
                                  <Form.Label>Histórico Médico Familiar:</Form.Label>
                                  <Form.Control as="textarea" rows={3} value={historicoMedicoFamiliar} onChange={(e) => { setHistoricoMedicoFamiliar(e.target.value); setIsFormDirty(true); }} />
                                </Form.Group>
                              </Col>
                              <Col md={7}>
                                <Form.Group className="mb-3" controlId="historicoMedicoFamiliar">
                                  <Form.Label>Observações Adicionais:</Form.Label>
                              <Form.Control as="textarea" rows={3} value={observacoesConsulta} onChange={(e) => { setObservacoesConsulta(e.target.value); setIsFormDirty(true); }} />
                                </Form.Group>
                              </Col>
                            </Row>
                            
                          </Form>
                        </Card.Body>
                      </Card>
                      
                      <Card>
                        <Card.Header as="h5" className="bg-primary bg-opacity-10"><FontAwesomeIcon icon={faUserMd} className="me-2" />Plano Clínico</Card.Header>
                        <Card.Body>
                          <Form>
                            <Row>
                              <Col md={6}>
                                <Form.Group className="mb-3" controlId="diagnostico">
                                  <Form.Label>Diagnóstico ou Hipótese Diagnóstica:</Form.Label>
                                  <Form.Control as="textarea" rows={3} value={diagnostico} onChange={(e) => { setDiagnostico(e.target.value); setIsFormDirty(true); }} />
                                </Form.Group>
                              </Col>
                              <Col md={6}>
                                <Form.Group className="mb-3" controlId="planoTratamento">
                                  <Form.Label>Plano de Tratamento:</Form.Label>
                                  <Form.Control as="textarea" rows={3} value={planoTratamento} onChange={(e) => { setPlanoTratamento(e.target.value); setIsFormDirty(true); }} />
                                </Form.Group>
                              </Col>
                              <Col md={3}>
                                <Form.Check type="switch" id="marcar-retorno" label="Marcar Retorno" checked={marcarRetorno} onChange={(e) => { setMarcarRetorno(e.target.checked); setIsFormDirty(true); }} />
                              </Col>
                              
                            </Row>
                            
                          </Form>
                        </Card.Body>
                      </Card>
                    </Tab>

                    <Tab 
                      eventKey="procedimentos" 
                      title={<><FontAwesomeIcon icon={faStethoscope} className="me-2" />Procedimentos</>}
                      disabled={!relatoConsulta.trim()}
                    >
                      <Row>
                        {/* Ajuste para ler os serviços do agendamento, não da consulta */}
                        <Col md={12} className="mb-3 text-end">
                          <Button variant="outline-success" onClick={handleOpenAddServiceModal}>
                            <FontAwesomeIcon icon={faPlus} className="me-2" /> Adicionar Serviço à Comanda
                          </Button>
                        </Col>
                          {/* NOVO: Seção de Desconto e Totalizador de Valor */}
                          <Col md={12} className="mt-3">
                            <Row className="justify-content-end align-items-end">
                              <Col md={4} lg={3}>
                                <Form.Group controlId="simulacao-desconto">
                                  <Form.Label>Desconto (%)</Form.Label>
                                  {/* NOVO: InputGroup para mostrar valor em R$ */}
                                  <InputGroup>
                                    <Form.Control
                                      type="number"
                                      value={discountPercentage}
                                      onChange={(e) => {
                                        let value = parseFloat(e.target.value) || 0;
                                        if (value < 0) value = 0;
                                        if (value > 5) value = 5;
                                        setDiscountPercentage(value);
                                      }}
                                      min="0"
                                      max="5"
                                      step="0.1"
                                    />
                                    <InputGroup.Text>
                                      (-{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(discountValue)})
                                    </InputGroup.Text>
                                  </InputGroup>
                                  <Form.Text muted>Máximo de 5%</Form.Text>
                                </Form.Group>
                              </Col>
                              <Col md={5} lg={4}>
                                <h5 className="text-end mb-2">Total Estimado: <span className="fw-bold">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(totalFinalEstimado)}</span></h5>
                              </Col>
                            </Row>
                          </Col>
                        {consultaAtual?.agendamento?.servicos?.length > 0 && (
                          <Col md={12} className="mb-3">
                            <Alert variant="info">
                              <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
                              <strong>Serviço(s) do Agendamento:</strong> {
                                consultaAtual.agendamento.servicos.map(s => s.nome).join(', ')
                              }.
                              <br />
                              <small>Você pode registrar o procedimento realizado com base no serviço agendado ou adicionar outros.</small>
                            </Alert>
                          </Col>
                        )}
                        <Col md={6}>
                          {/* NOVA SEÇÃO DE PROCEDIMENTOS */}
                          <h5>Registrar Procedimentos</h5>
                          <Accordion>
                            {/* AQUI ESTÁ A MUDANÇA PRINCIPAL: O map agora usa o estado `procedimentos` 
                               que é sincronizado com os serviços do agendamento (incluindo os da consulta) */}
                            {procedimentos && procedimentos.length > 0 ? (
                              procedimentos.map((proc, index) => (
                              <Accordion.Item eventKey={String(index)} key={index}>
                                <Accordion.Header>
                                  {`#${index + 1}: ${proc.nome || 'Novo Procedimento'}`}
                                </Accordion.Header>
                                <Accordion.Body>
                                  <Form.Group className="mb-2">
                                    <Form.Label>Nome do Procedimento</Form.Label>
                                    <CreatableSelect
                                        isClearable
                                        options={servicoOptions}
                                        value={proc.nome ? { value: proc.nome, label: proc.nome } : null}
                                        onChange={(newValue) => handleProcedimentoChange(index, 'nome', newValue ? newValue.value : '')}
                                        placeholder="Selecione ou digite um procedimento..."
                                        formatCreateLabel={inputValue => `Criar novo: \"${inputValue}\"`}
                                    />
                                  </Form.Group>
                                  <Form.Group as={Row} className="mb-2">
                                    <Col sm={7}>
                                      <Form.Label>Profissional Responsável</Form.Label>
                                      <Form.Control type="text" value={proc.profissional} onChange={(e) => handleProcedimentoChange(index, 'profissional', e.target.value)} />
                                    </Col>
                                    <Col sm={5}>
                                      <Form.Label>Data e Hora</Form.Label>
                                      <DatePicker selected={proc.dataHora} onChange={(date) => handleProcedimentoChange(index, 'dataHora', date)} showTimeSelect timeFormat="HH:mm" timeIntervals={15} dateFormat="dd/MM/yyyy HH:mm" className="form-control" />
                                    </Col>
                                    {/* NOVO: Campo de Quantidade */}
                                    <Col sm={3}>
                                      <Form.Group controlId={`proc-quantidade-${index}`}>
                                        <Form.Label>Quantidade</Form.Label>                                        
                                        <Form.Control
                                          type="number"
                                          value={proc.quantidade}
                                          onChange={(e) => handleProcedimentoChange(index, 'quantidade', parseInt(e.target.value, 10) || 1)}
                                          min="1"
                                          // Desabilita o campo se o serviço for um pacote
                                          disabled={servicos.find(s => s.nome === proc.nome)?.numero_sessoes > 1}
                                        />
                                      </Form.Group>
                                    </Col>
                                  </Form.Group>
                                  <Form.Group className="mb-2">
                                    <Form.Label>Observações</Form.Label>
                                    <Form.Control as="textarea" rows={3} value={proc.observacoes} onChange={(e) => handleProcedimentoChange(index, 'observacoes', e.target.value)} />
                                  </Form.Group>
                                  <Form.Group className="mb-2">
                                    <Form.Label>Material Utilizado</Form.Label>
                                    <Form.Control as="textarea" rows={2} value={proc.material} onChange={(e) => handleProcedimentoChange(index, 'material', e.target.value)} />
                                  </Form.Group>
                                  {procedimentos.length > 1 && (
                                    <Button variant="outline-danger" size="sm" onClick={() => handleRemoveProcedimento(index)}>
                                      <FontAwesomeIcon icon={faTrash} className="me-2" /> Remover
                                    </Button>
                                  )}
                                </Accordion.Body>
                              </Accordion.Item>
                            ))
                            ) : (
                              <p className="text-muted mt-2">Nenhum serviço/procedimento vinculado a esta consulta.</p>
                            )}
                          </Accordion>
                            {/* <Button variant="outline-primary" className="mt-2 w-100" onClick={handleAddProcedimento}>
                              <FontAwesomeIcon icon={faPlus} className="me-2" /> Adicionar Procedimento
                            </Button>                           */}
                          <Form.Group className="mb-3 mt-3" controlId="fotosConsulta">
                            <Form.Label className="text-center w-100">Fotos da Evolução</Form.Label>                            
                              <Row className="justify-content-center">
                                <Col xs="auto" className="text-center">
                                  {previewFotoAntes ? (
                                    <Image src={previewFotoAntes} thumbnail style={{ width: '113px', height: '151px', objectFit: 'cover', cursor: 'pointer' }} onClick={() => handlePreviewClick('antes', previewFotoAntes)} />
                                  ) : (
                                    <div className="img-thumbnail d-flex align-items-center justify-content-center text-muted" style={{ width: '113px', height: '151px', cursor: 'pointer', borderStyle: 'dashed', backgroundImage: `url(${capturaFotoIcon})`, backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: '50px' }} onClick={() => handleOpenCamera('antes')}></div>
                                  )}
                                </Col>
                                <Col xs="auto" className="text-center">
                                  {previewFotoDepois ? (
                                    <Image src={previewFotoDepois} thumbnail style={{ width: '113px', height: '151px', objectFit: 'cover', cursor: 'pointer' }} onClick={() => handlePreviewClick('depois', previewFotoDepois)} />
                                  ) : (
                                    <div className="img-thumbnail d-flex align-items-center justify-content-center text-muted" style={{ width: '113px', height: '151px', cursor: 'pointer', borderStyle: 'dashed', backgroundImage: `url(${capturaFotoIcon})`, backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: '50px' }} onClick={() => handleOpenCamera('depois')}></div>
                                  )}
                                </Col>
                            </Row>
                          </Form.Group>
                        </Col>
                      </Row>
                    </Tab>
                    
                    {/* Abas de Documentos e Assinatura agora são condicionais */}
                    {prontuarioTabsConfig.documentosConsulta && (
                      <Tab eventKey="documentos" title={<><FontAwesomeIcon icon={faUpload} className="me-2" />Anexar Docs</>}>
                        {consultaAtual && pacienteSelecionado && <DocumentosTab pacienteId={pacienteSelecionado.id} consultaId={consultaAtual.id} fetchOnMount={true} />}
                      </Tab>
                    )}
                    {prontuarioTabsConfig.assinatura && (
                      <Tab eventKey="assinatura" title={<><FontAwesomeIcon icon={faFileSignature} className="me-2" />Assinatura</>}>
                        {consultaAtual && <AssinaturaTab consultaId={consultaAtual.id} />}
                      </Tab>
                    )}
                  </Tabs>
                  {/* Botão de Salvar adicionado aqui para garantir sua visibilidade */}
                  <Row className="mt-4">
                    <Col className="text-end">
                      <Button variant="success" onClick={handleSaveAndFinish} disabled={isSaving || isSavingAndFinishing || !isFormDirty}>
                        {isSavingAndFinishing ? (
                          <><Spinner as="span" animation="border" size="sm" className="me-2" /> Finalizando...</>
                        ) : 'Salvar e Finalizar'}
                      </Button>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>

              <Card className="mb-3">
                <Card.Header>Habilitar Ferramentas da Consulta</Card.Header>
                <Card.Body>
                  <Form>
                    <Row>
                      <Col xs="auto"><Form.Check type="switch" id="toggle-receituario" label="Receituário" checked={prontuarioTabsConfig.receituario} onChange={() => handleTabConfigChange('receituario')} /></Col>
                      <Col xs="auto"><Form.Check type="switch" id="toggle-atestado" label="Atestado" checked={prontuarioTabsConfig.atestado} onChange={() => handleTabConfigChange('atestado')} /></Col>
                      <Col xs="auto"><Form.Check type="switch" id="toggle-laudos" label="Laudos" checked={prontuarioTabsConfig.laudos} onChange={() => handleTabConfigChange('laudos')} /></Col>
                      <Col xs="auto"><Form.Check type="switch" id="toggle-documentos" label="Documentos" checked={prontuarioTabsConfig.documentos} onChange={() => handleTabConfigChange('documentos')} /></Col>
                      <Col xs="auto"><Form.Check type="switch" id="toggle-documentos-consulta" label="Anexar Docs" checked={prontuarioTabsConfig.documentosConsulta} onChange={() => handleTabConfigChange('documentosConsulta')} /></Col>
                      <Col xs="auto"><Form.Check type="switch" id="toggle-assinatura" label="Assinatura" checked={prontuarioTabsConfig.assinatura} onChange={() => handleTabConfigChange('assinatura')} /></Col>
                    </Row>
                  </Form>
                </Card.Body>
              </Card>

            </div>
          )}

          {activeView === 'historico' && (
            <div id="historico-view">
              <Card>
                <Card.Header>Histórico de Consultas</Card.Header>
                <Card.Body style={{ maxHeight: '600px', overflowY: 'auto' }}>
                  {historico && historico.length > 0 ? ( 
                    <div className="timeline-container">
                  {historico.map((consulta) => {
                    let procedimentosRealizados = [];
                    try {
                      if (consulta.procedimentos) {
                        const parsed = Array.isArray(consulta.procedimentos) ? consulta.procedimentos : JSON.parse(consulta.procedimentos);
                        // Garante que é um array e que não está vazio ou com itens sem nome
                        if (Array.isArray(parsed) && parsed.length > 0 && parsed.some(p => p.nome)) {
                          procedimentosRealizados = parsed;
                        }
                      }
                    } catch (e) {
                      console.error("Erro ao parsear procedimentos do histórico:", e);
                    }

                    return (
                      <div key={consulta.id} className="timeline-item mb-3">
                        <div className="timeline-icon"><FontAwesomeIcon icon={faFileMedical} /></div>
                        <div className="timeline-content" style={{ marginLeft: '28px' }}>
                          <div className="timeline-date">{new Date(consulta.data_consulta).toLocaleDateString('pt-BR', { timeZone: 'UTC' })}</div>
                          <Row className="align-items-start">
                            <Col md={8}>
                              <p className="mb-1"><strong>Queixa:</strong> {consulta.queixa_principal || "Sem relato registrado."}</p>
                              {consulta.observacoes && <small className="text-muted d-block">Obs: {consulta.observacoes}</small>}
                            </Col>
                            <Col md={4} className="d-flex justify-content-md-end align-items-center mt-2 mt-md-0">
                              {consulta.foto_path_antes && <Image src={`${config.apiBaseURL}/storage/entidade/${currentEntidade.id}/fotos_pacientes/${consulta.foto_path_antes}`} alt="Antes" className="timeline-photo" onClick={() => handleOpenImageModal(`${config.apiBaseURL}/storage/entidade/${currentEntidade.id}/fotos_pacientes/${consulta.foto_path_antes}`)} />}
                              {consulta.foto_path_depois && <Image src={`${config.apiBaseURL}/storage/entidade/${currentEntidade.id}/fotos_pacientes/${consulta.foto_path_depois}`} alt="Depois" className="timeline-photo" onClick={() => handleOpenImageModal(`${config.apiBaseURL}/storage/entidade/${currentEntidade.id}/fotos_pacientes/${consulta.foto_path_depois}`)} />}
                            </Col>
                          </Row>
                          <Accordion className="mt-2">
                            <Accordion.Item eventKey={String(consulta.id)}>
                              <Accordion.Header>Ver detalhes da consulta</Accordion.Header>
                              <Accordion.Body>
                                <Row>
                                  <Col md={12}>
                                    <h6><FontAwesomeIcon icon={faHeartbeat} className="me-2" />Sinais Vitais</h6>
                                    <div className="small text-muted">
                                      <span>PA: <strong>{consulta.pressao_arterial || 'N/A'}</strong></span> | 
                                      <span> Temp: <strong>{consulta.temperatura || 'N/A'}°C</strong></span> | 
                                      <span> FC: <strong>{consulta.frequencia_cardiaca || 'N/A'} bpm</strong></span> | 
                                      <span> Sat O₂: <strong>{consulta.saturacao_oxigenio || 'N/A'}%</strong></span>
                                    </div>
                                    <hr />
                                  </Col>
                                  <Col md={6}>
                                    <h6><FontAwesomeIcon icon={faNotesMedical} className="me-2" />Diagnóstico</h6>
                                    <p className="small">{consulta.diagnostico || 'Nenhum diagnóstico registrado.'}</p>
                                  </Col>
                                  <Col md={6}>
                                    <h6><FontAwesomeIcon icon={faFilePrescription} className="me-2" />Prescrição</h6>
                                    <p className="small">{consulta.prescricao || 'Nenhuma prescrição registrada.'}</p>
                                  </Col>
                                  <Col md={12}><hr /></Col>
                                  <Col md={6}>
                                    <h6><FontAwesomeIcon icon={faFileSignature} className="me-2" />Plano de Tratamento</h6>
                                    <p className="small">{consulta.plano_tratamento || 'Nenhum plano de tratamento registrado.'}</p>
                                  </Col>
                                  <Col md={6}>
                                    <h6><FontAwesomeIcon icon={faStethoscope} className="me-2" />Procedimentos Realizados</h6>
                                    {procedimentosRealizados.length > 0 ? (
                                      <ul>
                                        {procedimentosRealizados.map((proc, index) => proc.nome && <li key={index}>{proc.nome}</li>)}
                                      </ul>
                                    ) : <p className="small">Nenhum procedimento registrado.</p>}
                                  </Col>
                                </Row>
                              </Accordion.Body>
                            </Accordion.Item>
                          </Accordion>
                        </div>
                          </div>
                    );
                  })}
                    </div>
                  ) : (
                    <p>Nenhum histórico de consulta encontrado.</p>
                  )}
                </Card.Body>
              </Card>
            </div>
          )}

          {activeView === 'anamnese_view' && pacienteSelecionado && (
            <div id="anamnese-view">
              <AnamneseViewTab pacienteId={pacienteSelecionado.id} />
            </div>
          )}

          {/* RENDERIZAÇÃO DA ABA DE ALERGIAS */}
          {activeView === 'alergias' && pacienteSelecionado && 
            <div id="alergias-view">
              <AlergiasTab pacienteId={pacienteSelecionado.id} />
            </div>
          }

          {/* PLACEHOLDER PARA NOVAS FUNCIONALIDADES */}
          {activeView === 'receituario' && consultaAtual && prontuarioTabsConfig.receituario && (
              <div id="receituario-view">
                  <Card>
                      <ReceituarioTab consultaId={consultaAtual.id} paciente={pacienteSelecionado} />
                  </Card>
              </div>
          )}

          {activeView === 'atestado' && consultaAtual && prontuarioTabsConfig.atestado && (
              <div id="atestado-view">
                  <Card>
                      <AtestadoTab consultaId={consultaAtual.id} paciente={pacienteSelecionado} />
                  </Card>
              </div>
          )}

          {/* A sugestão de Laudos pode usar o mesmo componente de Documentos, mas com um filtro */}
          {activeView === 'laudos' && prontuarioTabsConfig.laudos && <DocumentosTab pacienteId={pacienteSelecionado.id} consultaId={consultaAtual?.id} tipoFiltro="Laudo" />}

          {/* NOVO: Histórico completo de documentos, em modo de apenas leitura */}
          {activeView === 'documentos_historico' && prontuarioTabsConfig.documentos && <DocumentosTab pacienteId={pacienteSelecionado.id} readOnly={true} fetchOnMount={true} />}
        </Col>
      </Row>

      {/* NOVO: Modal para Adicionar Serviços */}
      <Modal show={showAddServiceModal} onHide={() => setShowAddServiceModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Adicionar Serviço à Comanda</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <p>Selecione os serviços adicionais realizados nesta consulta.</p>
        {isLoadingPacotes && <div className="text-center my-2"><Spinner size="sm" /> Verificando pacotes...</div>}
        <Form>
          <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
            {/* --- CORREÇÃO: Filtra para mostrar apenas serviços ativos --- */}
            {(servicos || []).filter(s => s.ativo).map(servico => {
              // Verifica se o serviço já está no agendamento original
              const isOriginalService = (servicosDoAgendamento || []).some(s => s.id === servico.id);
              // Verifica se o paciente tem um pacote ativo para este serviço
              const pacoteAtivo = pacientePacotesAtivos.find(p => p.servico_id === servico.id);
              const sessoesRestantes = pacoteAtivo ? pacoteAtivo.sessoes_contratadas - pacoteAtivo.sessoes_utilizadas : 0;

              return (
                <Form.Check 
                  type="checkbox"
                  key={servico.id}
                  id={`add-service-${servico.id}`}
                  label={
                    // O label agora mostra o nome, valor e se é um pacote
                    <>
                      {servico.nome} - {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(servico.valor)}
                      {pacoteAtivo && (
                        <Badge bg="info" className="ms-2">
                          Pacote ({sessoesRestantes} restantes)
                        </Badge>
                      )}
                    </>
                  }
                  checked={servicesToAdd.has(servico.id)}
                  onChange={() => handleToggleServiceToAdd(servico.id)}
                  // Desabilita o checkbox se o serviço já estiver na lista de procedimentos
                  disabled={procedimentos.some(p => p.nome === servico.nome)}
                />
              );
            })}
          </div>
        </Form>
      </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowAddServiceModal(false)} disabled={isAddingServices}>Cancelar</Button>
          <Button variant="primary" onClick={handleConfirmAddServices} disabled={isAddingServices || servicesToAdd.size === 0}>
            {isAddingServices ? <Spinner as="span" size="sm" /> : 'Adicionar Selecionados'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modais */}
      <Modal show={showImageOptionsMenu} onHide={() => setShowImageOptionsMenu(false)} centered size="sm">
        <Modal.Header closeButton><Modal.Title>Opções da Foto</Modal.Title></Modal.Header>
        <Modal.Body className="d-grid gap-2">
          <Button variant="outline-primary" type="button" onClick={() => { handleOpenImageModal(imageOptionsContext.url); setShowImageOptionsMenu(false); }}>
            <FontAwesomeIcon icon={faEye} className="me-2" />Visualizar Foto
          </Button>
          <Button variant="primary" type="button" onClick={() => { handleOpenCamera(imageOptionsContext.type); setShowImageOptionsMenu(false); }}>
            <FontAwesomeIcon icon={faCamera} className="me-2" />Alterar Foto
          </Button>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" type="button" onClick={() => setShowImageOptionsMenu(false)}>Cancelar</Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showImageModal} onHide={handleCloseImageModal} centered>
        <Modal.Header closeButton><Modal.Title>Visualizar Foto</Modal.Title></Modal.Header>
        <Modal.Body className="text-center">
          {modalImageUrl && <Image src={modalImageUrl} fluid style={{ maxHeight: '80vh' }} />}
        </Modal.Body>
      </Modal>

      <Modal show={showCameraModal} onHide={handleCloseCamera} centered>
        <Modal.Header closeButton><Modal.Title>Capturar Foto "{capturingFor}"</Modal.Title></Modal.Header>
        <Modal.Body className="text-center">
          {cameraStream ? (
            <video ref={videoRef} autoPlay playsInline muted style={{ width: '100%', maxWidth: '320px', aspectRatio: '3/4', objectFit: 'cover', border: '1px solid #ccc' }}></video>
          ) : (
            <p>Iniciando câmera...</p>
          )}
          <canvas ref={canvasRef} style={{ display: 'none' }}></canvas>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" type="button" onClick={handleCloseCamera}>Cancelar</Button>
          {videoDevices.length > 1 && (
            <Button variant="outline-info" type="button" onClick={handleSwitchCamera} disabled={isSwitchingCamera}>
              <FontAwesomeIcon icon={faSyncAlt} spin={isSwitchingCamera} className="me-2" />
              {isSwitchingCamera ? 'Alternando...' : 'Alternar Câmera'}
            </Button>
          )}
          <Button variant="primary" type="button" onClick={handleCapturePhoto} disabled={!cameraStream || isSwitchingCamera}>
            <FontAwesomeIcon icon={faCamera} className="me-2" />Capturar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal para exibir o código da Anamnese (QR Code) */}
      <Modal show={showAnamneseCodeModal} onHide={() => setShowAnamneseCodeModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Solicitar Anamnese Digital</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center py-4">
          <p className="mb-4">O paciente deve escanear o QR Code ou digitar o código no tablet/celular:</p>
          
          <div className="mb-4 p-3 bg-white d-inline-block border rounded shadow-sm">
            <QRCodeCanvas 
              value={`${window.location.origin}/anamnese/${anamneseCode}`}
              size={200}
              level={"H"}
              includeMargin={true}
            />
            <div className="mt-2 small text-muted">Acesso Instantâneo</div>
          </div>

          <div className="display-5 fw-bold text-primary mb-3" style={{ letterSpacing: '5px' }}>
            {anamneseCode}
          </div>

          <Alert variant="info" className="small">
            Esta janela fechará automaticamente assim que o paciente clicar em "Enviar Respostas".
          </Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowAnamneseCodeModal(false)}>Cancelar</Button>
        </Modal.Footer>
      </Modal>
    </Container>
    </TelehealthWorkspace>
  );
};

// Envolve o componente com React.memo para evitar re-renderizações desnecessárias
// quando as props (historico, consultaAtual, etc.) não mudam de valor.
const Prontuario = React.memo(ProntuarioComponent);
export default Prontuario;
